import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { MultimediaManagerDialogLayoutService } from '../multimedia-manager-dialog-layout/multimedia-manager-dialog-layout.service';
import { MultimediaManagerDialogItem, MultimediaManagerDialogItemTypes } from '../multimedia-manager-dialog/multimedia-manager-dialog-item.model';
import { MultimediaManagerDialogService } from '../multimedia-manager-dialog/multimedia-manager-dialog.service';
import { Mode } from '../multimedia-manager-dialog/multimedia-manager-dialog.component';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-multimedia-manager-dialog-item-details',
  templateUrl: './multimedia-manager-dialog-item-details.component.html',
  styleUrls: ['./multimedia-manager-dialog-item-details.component.scss']
})
export class MultimediaManagerDialogItemDetailsComponent implements OnInit, OnDestroy {

  @ViewChild('itemName', {static: false}) itemNameRef: ElementRef;
  @Input() currentFolder;
  open: boolean;
  item: MultimediaManagerDialogItem;
  webscript;
  weburl;
  editingName: boolean;
  deleteSubscription: Subscription;

  constructor(private multimediaManagerDialogLayoutService: MultimediaManagerDialogLayoutService,
              private multimediaManagerDialogService: MultimediaManagerDialogService,
              public sanitizer: DomSanitizer,
              private snackbarService: SnackBarService) {
                this.open = false;
                this.editingName = false;
              }

  ngOnInit() {
    this.multimediaManagerDialogLayoutService.listenShowDetails().subscribe(
      (item) => {
        this.item = item;
        this.open = true;
        switch (item.Type) {
          case MultimediaManagerDialogItemTypes.WEB_SCRIPT:
            this.sanitizeWebscript(item.Url);
          break;
          case MultimediaManagerDialogItemTypes.WEB_URL:
            this.sanitizeWeburl(item.Url);
          break;
        }
      }
    );
    this.multimediaManagerDialogLayoutService.listenHideDetails().subscribe(
      (res) => {
        this.open = false;
      }
    );
  }

  private sanitizeWebscript(webscript) {
    this.webscript = this.sanitizer.bypassSecurityTrustHtml(webscript);
  }
  private sanitizeWeburl(weburl) {
    this.weburl = this.sanitizer.bypassSecurityTrustResourceUrl(weburl);
  }
  public closeDetails() {
    this.open = false;
  }

  public enableNameEdition(input) {
    if (this.editingName === true) {
      this._updateElement(this.item);
    }
    this.itemNameRef.nativeElement.disabled = !this.itemNameRef.nativeElement.disabled;
    this.editingName = !this.editingName;
  }

  private _updateElement(element) {
    this.multimediaManagerDialogLayoutService.updateElement(element).subscribe(
      (res) => {

      },
      (error) => {

      }
    );
  }

  public edit() {
    this.multimediaManagerDialogService.setMode(Mode.editor, this.item);
  }

  public delete() {
    const itemArray = [];
    itemArray.push(this.item);
    this.deleteSubscription = this.multimediaManagerDialogLayoutService.deleteItem(itemArray).subscribe(
      (res) => {
        this.open = false;
        this.multimediaManagerDialogService.folderChanged(this.currentFolder);
      },
      (error) => {
        this.snackbarService.open('error', error);
      }
    );
  }

  public stopPropagation(e) {
    e.stopPropagation();
  }

  ngOnDestroy() {
    if (this.deleteSubscription) { this.deleteSubscription.unsubscribe(); }
  }
}
